module.exports = __webpack_public_path__ + "static/media/Montserrat-MediumItalic.40a74702.ttf";